import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ImageLink = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g filter="url(#filter0_bd_7108_20005)">
        <rect width="17.6" height="17.6" transform="translate(2.6001 2.7998)" fill="white" />
        <path d="M19.0806 3.91943V19.2806H3.71948L19.0806 3.91943Z" fill="url(#paint0_linear_7108_20005)" />
        <path d="M3.71943 19.2803V3.91914H19.0806L3.71943 19.2803Z" fill="url(#paint1_linear_7108_20005)" />
      </g>
      <g filter="url(#filter1_d_7108_20005)">
        <path
          d="M8.81692 10.5884L7.56861 11.8367C7.1024 12.3029 6.8343 12.9372 6.8392 13.6039C6.8441 14.2706 7.10633 14.9088 7.59467 15.3821C8.06789 15.8704 8.70624 16.1326 9.37282 16.1375C10.0546 16.1425 10.6739 15.8896 11.1402 15.4233L12.3885 14.175M13.983 12.611L15.2313 11.3627C15.6975 10.8965 15.9656 10.2622 15.9607 9.59549C15.9558 8.92881 15.6935 8.29059 15.2052 7.81734C14.7321 7.34423 14.0939 7.08198 13.4272 7.07708C12.7605 7.07218 12.1261 7.32506 11.6598 7.79129L10.4115 9.0396M9.50695 13.4593L13.2519 9.71438"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_bd_7108_20005"
          x="-2.59221"
          y="-2.3925"
          width="27.9847"
          height="27.9847"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.59615" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_7108_20005" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_7108_20005" result="effect2_dropShadow_7108_20005" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7108_20005" result="shape" />
        </filter>
        <filter
          id="filter1_d_7108_20005"
          x="4.08911"
          y="5.32715"
          width="14.6216"
          height="14.5605"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7108_20005" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7108_20005" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_7108_20005"
          x1="11.7841"
          y1="9.71477"
          x2="15.2403"
          y2="19.7693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6D00" />
          <stop offset="1" stopColor="#F8EF6F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7108_20005"
          x1="3.71943"
          y1="8.14345"
          x2="12.1331"
          y2="10.8666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47FF65" />
          <stop offset="1" stopColor="#2C99FF" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default ImageLink
